import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Eyebrow, Headline } from "@/components/Editorial";
import Button from "@/components/Button";
import TopWedge from "@/components/TopWedge";
import { apiGet } from "@/lib/api";
import { C } from "@/lib/brand";

export default function Done() {
  const [search] = useSearchParams();
  const cid = search.get("cid");
  const [c, setC] = useState(null);
  useEffect(() => {
    if (!cid) return;
    apiGet(`/consumer/consultations/${cid}`).then(setC).catch(() => {});
  }, [cid]);

  return (
    <div data-testid="done-page" style={{ minHeight: "100vh", background: C.cream }}>
      <section style={{ background: C.ink, color: C.cream, padding: "80px 24px 96px", textAlign: "center" }}>
        <div style={{ width: 88, height: 88, margin: "0 auto", background: C.sage, color: C.sageDark, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 40, fontWeight: 800 }}>
          ✓
        </div>
        <div style={{ marginTop: 28 }}><Eyebrow color={C.sage}>★ ALL SET</Eyebrow></div>
        <h1 style={{ marginTop: 22, fontSize: "clamp(48px, 9vw, 92px)", fontWeight: 800, letterSpacing: "-0.04em", lineHeight: 0.95, textTransform: "uppercase" }}>
          YOU'RE
          <br />
          <span style={{ fontFamily: '"Instrument Serif", serif', fontStyle: "italic", fontWeight: 400, textTransform: "none", color: C.sage }}>all set.</span>
        </h1>
        <p style={{ marginTop: 22, fontSize: 16, color: "rgba(250,246,240,0.75)" }}>
          Your assessment is in. A licensed physician will review and respond within 24 hours.
        </p>
      </section>

      <section style={{ padding: "68px 24px 80px", position: "relative", background: C.cream }}>
        <TopWedge color={C.ink} dir="right" />
        <div style={{ maxWidth: 720, margin: "0 auto", position: "relative", zIndex: 2 }}>
          <Eyebrow>WHAT HAPPENS NEXT</Eyebrow>
          <div style={{ marginTop: 24, display: "grid", gridTemplateColumns: "1fr", gap: 0 }}>
            {[
              { n: "01", t: "Physician review", s: "Within 24 hours, a licensed MD reviews your case.", bg: C.sage, fg: C.sageDark },
              { n: "02", t: "Approval & activation", s: "You'll get an email when ready. Activate your subscription on the My Plan tab.", bg: C.bone, fg: C.ink },
              { n: "03", t: "First shipment", s: "Discreet, fast shipping. Tracking shared via email.", bg: C.cream, fg: C.ink },
            ].map((s) => (
              <div key={s.n} data-testid={`done-step-${s.n}`} style={{ background: s.bg, color: s.fg, padding: "32px 28px", borderBottom: `1px solid ${C.warmGray4}` }}>
                <div style={{ fontFamily: '"Instrument Serif", serif', fontStyle: "italic", fontSize: 56, lineHeight: 0.9 }}>{s.n}</div>
                <div style={{ marginTop: 12, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>{s.t}</div>
                <div style={{ marginTop: 8, fontSize: 14, lineHeight: 1.6 }}>{s.s}</div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 36, textAlign: "center" }}>
            <Link to="/app/plan"><Button variant="primary" size="lg" testId="done-view-plan-btn">VIEW MY PLAN →</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
